import { about, updates, faqs, contactInfo } from '@/mocks/homeData';

export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            关于我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {about.title}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto mb-10 space-y-4">
          {about.paragraphs.map((p, i) => (
            <p key={i} className="text-foreground-700 leading-relaxed text-sm md:text-base">
              {p}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {about.highlights.map((h) => (
            <div key={h.label} className="bg-background-50 rounded-xl p-5 text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center">
                <i className={`${h.icon} text-2xl text-primary-500`}></i>
              </div>
              <div className="text-2xl font-bold text-foreground-950 mb-1 font-heading">{h.value}</div>
              <div className="text-xs text-foreground-500">{h.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            最新动态
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            平台动态与更新日志
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            关注四虎影视大全的最新变化，不错过每一次升级
          </p>
        </div>

        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-[11px] md:left-[15px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-6">
            {updates.map((u, i) => (
              <div key={i} className="relative">
                <div className="absolute left-[-22px] md:left-[-25px] top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <div className="bg-background-100 rounded-xl p-5 md:p-6">
                  <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-2.5 py-1 rounded mb-3">
                    {u.date}
                  </span>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{u.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{u.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            常见问答
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            你可能会关心的几个问题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            关于四虎影视大全的常见疑问，这里都有解答
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {contactInfo.title}
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            {contactInfo.description}
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg">
                  <i className="ri-mail-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">电子邮箱</div>
                  <div className="text-sm font-medium text-foreground-900">{contactInfo.email}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg">
                  <i className="ri-wechat-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">微信公众号</div>
                  <div className="text-sm font-medium text-foreground-900">{contactInfo.wechat}</div>
                </div>
              </div>
            </div>
            <div>
              <div className="text-sm font-semibold text-foreground-800 mb-3">我们为你提供</div>
              <ul className="space-y-2">
                {contactInfo.tips.map((tip, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}